import { useEffect, useRef, useState } from "react";
import { fileUrl } from "@/lib/api";
import { LayerBox } from "@/components/editor/LayerBox";

export const EditorCanvas = ({ page, layers, selectedId, onSelect, onChange }) => {
  const wrap = useRef();
  const pageRef = useRef();
  const [size, setSize] = useState({ w: 0, h: 0 });

  useEffect(() => {
    const el = wrap.current;
    const fit = () => {
      if (!page) return;
      const aw = el.clientWidth - 96, ah = el.clientHeight - 140;
      const ratio = page.width / page.height;
      const w = Math.min(aw, ah * ratio);
      setSize({ w, h: w / ratio });
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, [page]);

  return (
    <div ref={wrap} className="dot-grid relative flex flex-1 items-start justify-center overflow-auto pt-10 thin-scroll" onPointerDown={() => onSelect(null)} data-testid="editor-canvas">
      {page && (
        <div ref={pageRef} className="relative shrink-0 bg-white shadow-[0_24px_50px_-18px_rgba(100,116,139,.55)]" style={{ width: size.w, height: size.h }} data-testid="canvas-page">
          <img src={fileUrl(page.thumb)} alt="" className="absolute inset-0 h-full w-full" draggable={false} />
          <img src={fileUrl(page.lg)} alt={`Page ${page.index}`} className="absolute inset-0 h-full w-full" draggable={false} />
          {layers.map((l, i) => (
            <LayerBox key={l.id} layer={l} z={i + 1} selected={l.id === selectedId} pageRef={pageRef} onSelect={onSelect} onChange={onChange} />
          ))}
        </div>
      )}
    </div>
  );
};
